import { INDEX_METRIC_KEYS } from './indexMetrics';

export type ScreenerApiFilterValue = string | number | boolean | Array<string | number | boolean>;

export type ScreenerApiFilter = {
  metric: string;
  operator: string;
  value: ScreenerApiFilterValue;
};

const INDEX_METRIC_KEY_SET = new Set<string>(INDEX_METRIC_KEYS);

export const buildScreenerApiFilters = (
  filters: Record<string, string>
): ScreenerApiFilter[] => {
  const apiFilters: ScreenerApiFilter[] = [];
  const includedIndexes: string[] = [];

  Object.entries(filters).forEach(([metric, serializedFilter]) => {
    if (!serializedFilter) return;

    const { operator, value } = JSON.parse(serializedFilter);

    if (INDEX_METRIC_KEY_SET.has(metric) && operator === 'equals' && value === true) {
      includedIndexes.push(metric);
      return;
    }

    apiFilters.push({ metric, operator, value });
  });

  if (includedIndexes.length > 0) {
    apiFilters.unshift({
      metric: 'index_membership',
      operator: 'index_member',
      value: includedIndexes,
    });
  }

  return apiFilters;
};
